/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  GetTransactionsOptions,
  GetTransactionsStatus200,
  GetTransactionsStatus400,
  GetTransactionsStatus500,
} from '../types/GetTransactions'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { getTransactions } from '../clients/getTransactions'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getTransactionsQueryKey = ({ query }: Omit<GetTransactionsOptions, 'headers'> = {}) =>
  [{ url: '/v1/transactions' }, ...(query ? [query] : [])] as const

type GetTransactionsQueryKey = ReturnType<typeof getTransactionsQueryKey>

export function getTransactionsQueryOptions(
  { query }: GetTransactionsOptions = {},
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const queryKey = getTransactionsQueryKey({ query })
  return queryOptions<
    GetTransactionsStatus200,
    ResponseErrorConfig<GetTransactionsStatus400 | GetTransactionsStatus500>,
    GetTransactionsStatus200,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getTransactions({
        ...config,
        query,
        signal: config.signal ?? signal,
        throwOnError: true,
      }).unwrap()
    },
  })
}

/**
 * @description Role-based date window: public callers are limited to the last month; authenticated callers may query up to the last six months. If `start` is omitted it defaults to the role-based minimum. If credentials are supplied but invalid, the request is rejected as unauthorized.
 * @summary Get a filtered, paginated list of transactions
 * {@link /v1/transactions}
 */
export function useGetTransactions<
  TData = GetTransactionsStatus200,
  TQueryData = GetTransactionsStatus200,
  TQueryKey extends QueryKey = GetTransactionsQueryKey,
>(
  {
    query,
  }: { query?: GetTransactionsOptions['query'] | (() => GetTransactionsOptions['query']) } = {},
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetTransactionsStatus200,
        ResponseErrorConfig<GetTransactionsStatus400 | GetTransactionsStatus500>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const resolvedParams = { query: typeof query === 'function' ? query() : query }
  const queryKey = resolvedOptions?.queryKey ?? getTransactionsQueryKey(resolvedParams)

  const queryResult = useQuery(
    {
      ...getTransactionsQueryOptions(resolvedParams, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<GetTransactionsStatus400 | GetTransactionsStatus500>
  > & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
